import React from 'react'
import { Provider } from '@naturacosmeticos/natds-web/dist/Provider'

const TopLayout = ({ children, theme }) => (
  <Provider theme={theme}>{children}</Provider>
)

export default TopLayout
